const MAX_DIGIT = 4

export default function transformClip(
  clipName,
  cardWidth,
  cardHeight,
  smallSize = false,
  returnOnlyScaleFactor = false
) {
  function createTranslate(svgWidth, svgHeight) {
    let scaleFactorWidth = (cardWidth * (smallSize ? 0.81 : 1.00)) / svgWidth;
    let scaleFactorHeight = (cardHeight * (smallSize ? 0.81 : 1.00)) / svgHeight;

    let width = svgWidth * (scaleFactorWidth < scaleFactorHeight ?  scaleFactorWidth : scaleFactorHeight);
    let height = svgHeight * (scaleFactorWidth < scaleFactorHeight ?  scaleFactorWidth : scaleFactorHeight);



    if(returnOnlyScaleFactor){
      return Number(svgHeight * (scaleFactorWidth < scaleFactorHeight ?  scaleFactorWidth : scaleFactorHeight)).toFixed(MAX_DIGIT)
    }

    return `translate(${Number((cardWidth - width) / 2).toFixed(MAX_DIGIT)} ${Number((cardHeight - height) / 2).toFixed(MAX_DIGIT)}) scale(${Number(scaleFactorWidth < scaleFactorHeight ?  scaleFactorWidth : scaleFactorHeight).toFixed(MAX_DIGIT)})`;

    // const scaleDirection = 'horizontal'

    // let width =
    //   svgWidth *
    //   (scaleDirection === 'horizontal' ? scaleFactorWidth : scaleFactorHeight);
    // let height =
    //   svgHeight *
    //   (scaleDirection === 'horizontal' ? scaleFactorWidth : scaleFactorHeight);

    // return `translate(${(cardWidth - width) / 2} ${
    //   (cardHeight - height) / 2
    // }) scale(${
    //   scaleDirection === 'horizontal' ? scaleFactorWidth : scaleFactorHeight
    // })`;

  }

  switch (clipName) {
    case 'sanduhr_hochformat':
      return createTranslate(284.462, 387.572);
    case 'sanduhr_querformat':
      return createTranslate(385.092, 284.46);
    case 'sanduhr_quadratformat':
      return createTranslate(285.288, 285.286);
    case 'keks_hochformat':
      return createTranslate(295.85, 392.168);
    case 'keks_querformat':
      return createTranslate(392.168, 295.85);
    case 'keks_quadratformat':
      return createTranslate(293.767, 293.772);
    case 'blume_hochformat':
      return createTranslate(287.195, 386.472);
    case 'blume_querformat':
      return createTranslate(386.472, 287.195);
    case 'blume_quadratformat':
      return createTranslate(307.544, 309.965);
    case 'sanduhr_grafik':
      return createTranslate(182.639, 182.655);
    case 'keks_grafik':
      return createTranslate(192.635, 192.635);
    case 'blume_grafik':
      return createTranslate(191.124, 191.124);
    default:
      return '';
  }
}


export function getClipRatio(clipName) {
  switch (clipName) {
    case 'sanduhr_hochformat':
      return 284.462 / 387.572;
    case 'sanduhr_querformat':
      return 385.092 / 284.46;
    case 'sanduhr_quadratformat':
      return 285.288 / 285.286;
    case 'keks_hochformat':
      return 295.85 / 392.168;
    case 'keks_querformat':
      return 392.168 / 295.85;
    case 'keks_quadratformat':
      return 293.767 / 293.772;
    case 'blume_hochformat':
      return 287.195 / 386.472;
    case 'blume_querformat':
      return 386.472 / 287.195;
    case 'blume_quadratformat':
      return 307.544 / 309.965;
    case 'sanduhr_grafik':
      return 182.639 / 182.655;
    case 'keks_grafik':
      return 192.635 / 192.635;
    case 'blume_grafik':
      return 191.124 / 191.124;
    default:
      return 1;
  }
}
